import { styled } from '@mui/material';

export const StyledLayout = styled('div')(() => ({
  display: 'flex',
}));

export const Aside = styled('div')(() => ({
  width: '205px',
  height: '100%',
}));

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: 'calc(100% - 205px)',
}));

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  minHeight: 'calc(100vh + 54px)',
  padding: '32px',
  backgroundColor: theme.palette.grey[600],
}));

export const Entry = styled('div')(() => ({
  width: '100%',
  maxWidth: '1170px',
}));
